import React from 'react';
import classNames from 'classnames';
import Modal from 'react-modal';

type Props = {
  isOpen: boolean,
  closeOnOverlayClick?: boolean,
  modalHeading: string,
  closeModal: Function,
  isFetching?: boolean,
  children: any,
  modalHeadingImage?: any,
  width?: string,
  height?: string,
  noBodyPadding?: boolean,
  isScrollable?: boolean,
};

function HdModal(props: Props) {
  const {
    isOpen,
    closeOnOverlayClick,
    modalHeading,
    closeModal,
    isFetching,
    children,
    modalHeadingImage,
    width,
    height,
    noBodyPadding,
    isScrollable
  } = props;
  const customWidth = {
    content: {
      width: width || 'auto',
      height: height || 'auto',
    },
  };

  const customHeight = classNames({
    grid: true,
    modal__scrollable: isScrollable,
  });

  const customBodyPadding = noBodyPadding
    ? 'col__1-1 u--paddingNone'
    : 'col__1-1 u--paddingNormal';
  return (
    <Modal
      ariaHideApp={false}
      shouldCloseOnOverlayClick={closeOnOverlayClick}
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="THD Modal"
      className="u__modal"
      overlayClassName="u__modal--overlay"
      style={customWidth}
    >
      <div className={customHeight}>
        <div className="col__12-12 u__border--bottom u--paddingNormal">
          <div className="shipment-modal__title col__10-12 u--paddingNone">
            {modalHeadingImage && (
              <img
                data-automation-id="modal-heading-logo"
                className="shipment-modal__logo-image u--margin-right"
                src={modalHeadingImage}
                alt="modal-heading-logo"
              />
            )}
            <span className="u__medium" data-automation-id="modalHeading">
              {modalHeading}
            </span>
          </div>
          <div className="col__2-12 u--paddingNone">
            <button
              data-automation-id="modalCloseButton"
              className="mw-icon-menu-close u__text--brand u__medium u__right"
              type="button"
              onClick={closeModal}
            />
          </div>
        </div>
        {isFetching ? (
          <div className="col__1-1 u--paddingNormal u__text-align--center">
            <span
              data-automation-id="modalSpinner"
              className="segment-spinner"
            />
          </div>
        ) : (
          <div className={customBodyPadding}>{children}</div>
        )}
      </div>
    </Modal>
  );
}

HdModal.defaultProps = {
  closeOnOverlayClick: false,
  isFetching: false,
  modalHeadingImage: null,
  width: null,
  height: null,
  noBodyPadding: false,
  isScrollable: false,
};

export default HdModal;
